const { registerPlugin } = require('@capacitor/core');

const App = registerPlugin('App');

module.exports = { App };
